<template>
    <DashboardWidget canGoFullscreen title="Stato Patrimoniale" class="stato-patrimoniale-widget no-overflow" dialog-class="modal--type-dashboard-widget modal--type-dashboard-widget-stato-patrimoniale">
    <OperativeTable dense>
      <tbody>
        <OperativeTableBodyHeader :years="[values.year]" show-years>Impieghi</OperativeTableBodyHeader>
        <OperativeTableBodyRow :values="[values.attivoImmobilizzato]">
          Attivo immobilizzato
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.scorte]">
          Scorte
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.clienti]">
          Clienti
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.creditiTributari]">
          Crediti tributari
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.altriCrediti]">
          Altri crediti
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.creditoImposta]">
          Credito d'imposta
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.liquiditaImmediate]">
          Liquidità immediate
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.totaleCapitaleInvestito]" strong>
          Totale capitale investito
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>

        <OperativeTableBodyHeader :years="[values.year]" show-years>Fonti</OperativeTableBodyHeader>
        <OperativeTableBodyRow :values="[values.patrimonioNetto]" strong>
          Patrimonio netto
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.equity]" strong>
          Equity
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.capitaleSociale]">
          Capitale sociale
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.riserve]">
          Riserve
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.prestitoSoci]">
          Prestito soci
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.utiliPerditePregresse]">
          Utili/Perdite pregresse
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.utilePerdita]">
          Utile/Perdita
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.passivitaConsolidate]" strong>
          Passività consolidate
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.finanziamentiMLTermine]">
          Finanziamenti a Medio/Lungo Termine
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.fondi]">
          Fondi
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.passivitaCorrenti]" strong>
          Passività correnti
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.bancheBreve]">
          Banche a breve
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.rateMLTermineScadenza]">
          Rate Medio/Lungo Termine in scadenza
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.fornitori]">
          Fornitori
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.fiscaliPrevidenziali]">
          Fiscali e previdenziali
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.altriDebiti]">
          Altri debiti
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.riscontiPassivi]">
          Risconti passivi
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.totaleCapitaleAcquisito]" strong>
          Totale capitale acquisito
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
      </tbody>
    </OperativeTable>

    <template #fullscreen>
      <table class="table">
        <tr>
          <td>
            <OperativeTable>
              <tbody>
              <OperativeTableBodyHeader :years="[values.year]" show-years>Impieghi</OperativeTableBodyHeader>
              <OperativeTableBodyRow :values="[values.attivoImmobilizzato]">
                Attivo immobilizzato
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.scorte]">
                Scorte
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.clienti]">
                Clienti
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.creditiTributari]">
                Crediti tributari
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.altriCrediti]">
                Altri crediti
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.creditoImposta]">
                Credito d'imposta
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.liquiditaImmediate]">
                Liquidità immediate
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.totaleCapitaleInvestito]" strong>
                Totale capitale investito
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              </tbody>
            </OperativeTable>
          </td>
          <td>
            <OperativeTable>
              <tbody>
              <OperativeTableBodyHeader :years="[values.year]" show-years>Fonti</OperativeTableBodyHeader>
              <OperativeTableBodyRow :values="[values.patrimonioNetto]" strong>
                Patrimonio netto
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.equity]" strong>
                Equity
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.capitaleSociale]">
                Capitale sociale
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.riserve]">
                Riserve
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.prestitoSoci]">
                Prestito soci
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.utiliPerditePregresse]">
                Utili/Perdite pregresse
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.utilePerdita]">
                Utile/Perdita
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.passivitaConsolidate]" strong>
                Passività consolidate
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.finanziamentiMLTermine]">
                Finanziamenti a Medio/Lungo Termine
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.fondi]">
                Fondi
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.passivitaCorrenti]" strong>
                Passività correnti
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.bancheBreve]">
                Banche a breve
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.rateMLTermineScadenza]">
                Rate Medio/Lungo Termine in scadenza
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.fornitori]">
                Fornitori
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.fiscaliPrevidenziali]">
                Fiscali e previdenziali
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.altriDebiti]">
                Altri debiti
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.riscontiPassivi]">
                Risconti passivi
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              <OperativeTableBodyRow :values="[values.totaleCapitaleAcquisito]" strong>
                Totale capitale acquisito
                <template #cell-content="{ value }">{{ value | money }}</template>
              </OperativeTableBodyRow>
              </tbody>
            </OperativeTable>
          </td>
        </tr>
      </table>
    </template>
  </DashboardWidget>
</template>

<script>

import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  components: {
    DashboardWidget: () => import('./DashboardWidget'),
    OperativeTable: () => import('../../Operative/OperativeTable'),
    OperativeTableBodyHeader: () => import('../../Operative/OperativeTableBodyHeader'),
    OperativeTableBodyRow: () => import('../../Operative/OperativeTableBodyRow'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    values: {
      type: Object,
      default: () => ({}),
    },
  },
};

</script>

<style lang="scss">

.stato-patrimoniale-widget {
  .operative-table-value-column {
    min-width: 1px;
  }
}

.modal--type-dashboard-widget-stato-patrimoniale {
  max-width: 70%;
  max-height: 80vh;

  @include media-breakpoint-down("md") {
    max-width: 100%;
  }

  .modal-body > .table > tr > td {
    width: 50%;

    @include media-breakpoint-down("md") {
      width: 100%;
      display: block;
    }
  }

  .operative-table .operative-table-header-column {
    min-width: 100px;
  }
}

</style>
